/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_CallInputs */

const cs_enum_call = /** @type {(inputs: Enum_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hovor`)
};

const en_enum_call = /** @type {(inputs: Enum_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Call`)
};

/**
* | output |
* | --- |
* | "Call" |
*
* @param {Enum_CallInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_call = /** @type {((inputs?: Enum_CallInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_CallInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_call(inputs)
	return cs_enum_call(inputs)
});